module.exports = __webpack_public_path__ + "img/Quotesymbol.svg";


//////////////////
// WEBPACK FOOTER
// ./img/Quotesymbol.svg
// module id = 239
// module chunks = 0